import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Form from '../form/Form';
import { cfpFieldGroups } from '../field_group/CFPFields';
import FieldGroup from '../field_group/FieldGroup';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';
import { listACBrand } from '../../redux/references/ac_actions';

// FRS 4.2.1 revision 20260826 - VRF Outdoor Unit form (TOR 4.2.1 หน้า 3-5)
// ตัดออก (Q1-Q6 ที่ลูกค้ายืนยัน 2026-09-11): code, type (air/water), test standard,
// linked indoor types (ย้ายไปผูกที่ VRF System แทน), แท็บ "Calculation Result"
// (Q_net/P_total/Connection Ratio) ทั้งหมด, badge ระดับ กฟผ.
// เพิ่ม: Cooling Capacity + Unit (เหมือน Indoor), Fan Power (kW) ของตัวเอง (Q3)
// COP มาจาก SEER ÷ 3.412 ตรงๆ (property จาก backend) — แสดงแบบ read-only เฉยๆ
export class VRFOutdoorDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  componentDidMount() {
    this.props.listBrand();
  }

  renderOption(item, prefix) {
    return (
      <option key={prefix ? `${prefix}${item.id}` : item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  getData() {
    return this.formRef.getFormData([]);
  }

  render() {
    const {
      name,
      brand_id,
      cooling_capacity,
      unit,
      power,
      fan_power,
      seer,
      cop,
      cfp_value,
      cfp_unit,
      description,
      image,
    } = this.props.outdoor;

    const { t, disabled, fieldErrors, ...otherAttr } = this.props;
    const customAttr = { disabled };

    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => (this.formRef = ref)}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="vrf-outdoor-name"
          field="name"
          type="text"
          label={t('name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="vrf-outdoor-brand"
          field="brandId"
          componentClass="select"
          label={t('brand')}
          value={brand_id}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.brands.map(brand => this.renderOption(brand, 'vrfb'))}
        </FieldGroup>
        <FieldGroup
          id="vrf-outdoor-cooling-capacity"
          field="coolingCap"
          type="number"
          label={t('cooling capacity')}
          placeholder="12"
          value={cooling_capacity}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'cooling_capacity')}
          {...customAttr}
        />
        <FieldGroup
          id="vrf-outdoor-unit"
          field="unitId"
          componentClass="select"
          label={t('unit')}
          value={unit}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.units.map(u => this.renderOption(u, 'vrfu'))}
        </FieldGroup>
        <FieldGroup
          id="vrf-outdoor-power"
          field="power"
          type="number"
          label={t('power (kW)')}
          placeholder="12"
          value={power}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'power')}
          {...customAttr}
        />
        <FieldGroup
          id="vrf-outdoor-fan-power"
          field="fanPower"
          type="number"
          label={t('fan power (kW)')}
          placeholder="0.5"
          value={fan_power}
          errorMessage={getErrorValue(fieldErrors, 'fan_power')}
          {...customAttr}
        />
        <FieldGroup
          id="vrf-outdoor-seer"
          field="seer"
          type="number"
          label={t('SEER')}
          placeholder="20"
          value={seer}
          errorMessage={getErrorValue(fieldErrors, 'seer')}
          {...customAttr}
        />
        {cop != null && (
          <div className="form-group">
            <label>{t('COP')}</label>
            <p className="form-control-static">{cop}</p>
          </div>
        )}
        {cfpFieldGroups({ cfp_value, cfp_unit, disabled, fieldErrors, t })}
        <FieldGroup
          id="vrf-outdoor-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

VRFOutdoorDetail.defaultProps = {
  outdoor: {},
};

const mapStateToProps = state => ({
  brands: state.reference.ac.brandList,
  units: state.reference.ac.coolingCapacityUnit,
});

const mapDispatchToProps = dispatch => ({
  listBrand: () => dispatch(listACBrand()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(VRFOutdoorDetail),
);



// WEBPACK FOOTER //
// ./src/components/vrf/VRFOutdoorDetail.js